module.exports = __webpack_public_path__ + "static/media/Yrsa-Bold.517d13eb.ttf";